import React from 'react';
import { Home, Utensils, Bed, Bath, Sofa, Droplets } from 'lucide-react';
import { Card } from '../ui/Card';
import { useLanguage } from '../../contexts/LanguageContext';
interface RoomSelectionProps {
  selectedRoom: string;
  onSelectRoom: (room: string) => void;
}
export const RoomSelection: React.FC<RoomSelectionProps> = ({
  selectedRoom,
  onSelectRoom
}) => {
  const {
    t
  } = useLanguage();
  const rooms = [{
    id: 'kitchen',
    name: t.roomSelection.rooms.kitchen,
    icon: Utensils
  }, {
    id: 'bedroom',
    name: t.roomSelection.rooms.bedroom,
    icon: Bed
  }, {
    id: 'bathroom',
    name: t.roomSelection.rooms.bathroom,
    icon: Bath
  }, {
    id: 'livingRoom',
    name: t.roomSelection.rooms.livingRoom,
    icon: Sofa
  }, {
    id: 'laundry',
    name: t.roomSelection.rooms.laundry,
    icon: Droplets
  }, {
    id: 'other',
    name: t.roomSelection.rooms.other,
    icon: Home
  }];
  return <div data-id="element-583">
      <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-584">
        {t.roomSelection.title}
      </h2>
      <p className="text-gray-600 mb-8" data-id="element-585">{t.roomSelection.subtitle}</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-6" data-id="element-586">
        {rooms.map(room => {
        const Icon = room.icon;
        return <Card key={room.id} className={`min-h-[160px] cursor-pointer transition-all hover:shadow-lg ${selectedRoom === room.id ? 'ring-2 ring-teal-deep bg-teal-50' : 'hover:bg-gray-50'}`} onClick={() => onSelectRoom(room.id)} data-id="element-587">
              <div className="flex flex-col items-center justify-center h-full text-center p-6" data-id="element-588">
                <Icon className={`w-12 h-12 mb-4 ${selectedRoom === room.id ? 'text-teal-deep' : 'text-gray-400'}`} data-id="element-589" />
                <span className={`font-medium text-lg ${selectedRoom === room.id ? 'text-teal-deep' : 'text-gray-700'}`} data-id="element-590">
                  {room.name}
                </span>
              </div>
            </Card>;
      })}
      </div>
    </div>;
};